import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ADD_ITEM_BUTTON: `${cleanedFilename(__filename)}-add-item-button`,
};
